import { Component } from '@angular/core';
import { ApiService, BaseComponent } from '@nstep-common/core';
import { Enviroment } from '@nstep-common/core';
import { SessionService } from 'projects/common/core/services/auth/session.service';

@Component({
	selector: 'app-root',
	templateUrl: 'app.component.html',
	styleUrls: ['./app.component.css'],
	standalone: false
})
export class AppComponent extends BaseComponent {

	constructor(private apiService: ApiService,
		private sessionService: SessionService,
		private environment: Enviroment) {
		super();

		this.registerPerformanceObserver(this.apiService, this.sessionService, this.environment);
	}
}
